import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { Router } from '@angular/router';
import { CompanyService } from 'src/app/service/company.service';
import { ReportService } from 'src/app/service/report.service';
import { DataSharingService } from 'src/app/Service/datasharing.service';
import { ConfigurationsService } from 'src/app/Service/configurations.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-usermenu',
  templateUrl: './usermenu.component.html',
})
export class UsermenuComponent implements OnInit {
  roleName = localStorage.getItem('RoleName');

  @Input() clickOnProfile: boolean = false;
  clickOnmenu: boolean = true;
  isbelow813: boolean;
  blueImage: any = 0;
  blueColor: any = 0;
  UserName: string = '';
  RoleName: string = localStorage.getItem('RoleName');
  LoginId: string = '';
  ScreenList: any;
  DashboardList = [];
  AdminList = [];
  ReportList = [];
  ControlList = [];
  ServiceDetailsList: any = [];
  Datalist = [];
  Processlist = [];
  MeterReportList = [];
  ProductionReportslist = [];
  nameIcon: string = '';
  screenlabel: string = '';
  CompanyName: string = '';
  isDisplay: boolean = false;
  MeterMasterId: number = 0;

  ScreenPath = {
    DAILYREPORT: '/admin/reportmenu',
    Reports: '/admin/reportmenu',
    UPDATECOMPANY: '/admin/addcompany',
    COMPANYMASTER:
      this.RoleName != 'Admin'
        ? '/admin/companymaster'
        : '/admin/admincompanymaster',
    USERMASTER: '/admin/usermanagement',
    PUMPCONTROL: '/admin/control',
    DASHBOARD: '/admin/debtronics-dashboard',
    ASSIGNCOMPANY: '',
    UNLOCKUSER: '',
    ASSIGNMETER: '',
    DASHBOARDCONFIG: '/admin/dashboardconfig',
    REPORTCONFIG: '/admin/reportconfig',
    MeterReports: '/admin/meterreportmenu',
    USERCONTROL: '/admin/usercontrol',
    PARAMETERCONFIG: '/admin/parameterconfig',
    REGISTERAVERAGE: '/admin/average',
    GRAPHCONFIG: '/admin/graphconfig',
    LIVEDATA:
      this.RoleName != 'PortalAdmin'
        ? '/common/livedata'
        : '/admin/graphconfig',
    PACKETDETAILS: '/admin/packetdetails',
    PROCESSES: '/admin/processes',
    DIAMETERMASTER: '/admin/diametermaster',
    SIZEMASTER: '/admin/sizemaster',
    VOLUMEMASTER: '/admin/volumemaster',
    EMPLOYEEMASTER: '/admin/employeemaster',
    ITEMMASTER: '/admin/itemmaster',
    LOADCHART: '/admin/load-chart',
    SPARECONSUMPTION: '/admin/service-history-report',
    SERVICEDETAILS: '/admin/service-master',
    MAINTENANCEALERT: '/admin/maintenance-alert',
    ALERTMASTER: '/admin/alertmaster',
    ALERTDETAILSREPORT: '/admin/alert-details-report'
  };
  ImagePath = {
    COMPANYMASTER: 'assets/images/company-master.svg',
    USERMASTER: 'assets/images/user-master12.svg',
    UNLOCKUSER: 'assets/images/unlock_icon.svg',
    DASHBOARDCONFIG: 'assets/images/Dasboard_Config.svg',
    REPORTCONFIG: 'assets/images/Report config.svg',
    PUMPCONTROL: 'assets/images/Pump Control.svg',
    USERCONTROL: 'assets/images/User control.svg',
    PARAMETERCONFIG: 'assets/images/Parameter config.svg',
    REGISTERAVERAGE: 'assets/images/Register_Average.svg',
    GRAPHCONFIG: 'assets/images/GraphConfiguration.svg',
    LIVEDATA: 'assets/images/Report config.svg',
    PACKETDETAILS: 'assets/images/Report config.svg',
    PROCESSES: 'assets/images/Report config.svg',
    SIZEMASTER: 'assets/images/Report config.svg',
    DIAMETERMASTER: 'assets/images/Report config.svg',
    VOLUMEMASTER: 'assets/images/Report config.svg',
    EMPLOYEEMASTER: 'assets/images/user-master12.svg',
    ITEMMASTER: 'assets/images/user-master12.svg',
    LOADCHART: 'assets/images/user-master12.svg',
    SPARECONSUMPTION: 'assets/images/user-master12.svg',
    SERVICEDETAILS: 'assets/images/user-master12.svg',
    MAINTENANCEALERT: 'assets/images/MaintenanceAlertEmail.svg',
    ALERTMASTER: 'assets/images/MaintenanceAlertEmail.svg',
    ALERTDETAILSREPORT: 'assets/images/MaintenanceAlertEmail.svg'
  };
  logopath: string = '';
  CompanyCode: string;
  @Output() SideMenuclicked: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  screenHeight: number;
  screenWidth: number;
  IsDisplayUserManual: string;
  IsForProcesses: string;
  constructor(
    private userService: AuthService,
    private companyservice: CompanyService,
    private configService: ConfigurationsService,
    private router: Router,
    private reportservice: ReportService,
    private dataSharingService: DataSharingService,
    private http: HttpClient
  ) {
    this.dataSharingService.isDisplay.subscribe((value) => {
      this.isDisplay = value;
    });

    this.dataSharingService.EnergymeterMasterId.subscribe((value) => {
      this.MeterMasterId = value;
      if (this.MeterMasterId > 0) {
        this.GetMeterReportDetails(this.MeterMasterId);
      }
    });
  }

  // Host listener to apply css based on window size
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 813) {
      this.isbelow813 = true;
    } else {
      this.isbelow813 = false;
    }
  }

  ngOnInit(): void {
    this.http.get('assets/config/config.json').subscribe((response) => {
      if (response != null) {
        response['IsDisplayUserManual'] == 'Y'
          ? (this.IsDisplayUserManual = 'Y')
          : (this.IsDisplayUserManual = 'N');
      }
    });
    this.screenlabel = this.router.url.split('/')[2];
    this.CompanyCode = localStorage.getItem('CompanyCode');
    setTimeout(() => {
      this.GetCompanyDetails(this.CompanyCode);
    }, 2000);
    this.CompanyName = localStorage.getItem('CompanyName');
    this.LoginId = localStorage.getItem('LoginId');
    this.UserName = localStorage.getItem('UserName');
    var firstname = this.UserName.split(' ')[0];
    var lastname = this.UserName.split(' ')[1];
    this.nameIcon =
      firstname.charAt(0).toUpperCase() + lastname.charAt(0).toUpperCase();
    this.ScreenList = JSON.parse(localStorage.getItem('ScreenList'));
    localStorage.setItem('isAssignedUpdateCompany', 'N');
    localStorage.setItem('isAssignedAssignCompany', 'N');
    localStorage.setItem('isAssignedAssignMeter', 'N');

    for (let data of this.ScreenList) {
      if (data.ModuleName == 'Admin') {
        if (
          data.ScreenCode != 'UPDATECOMPANY' &&
          data.ScreenCode != 'ASSIGNCOMPANY' &&
          data.ScreenCode != 'ASSIGNMETER'
        ) {
          this.AdminList.push(data);
        } else if (data.ScreenCode == 'UPDATECOMPANY') {
          localStorage.setItem('isAssignedUpdateCompany', 'Y');
        } else if (data.ScreenCode == 'ASSIGNCOMPANY') {
          localStorage.setItem('isAssignedAssignCompany', 'Y');
        } else if (data.ScreenCode == 'ASSIGNMETER') {
          localStorage.setItem('isAssignedAssignMeter', 'Y');
        }
      } else if (data.ModuleName == 'Report') {
        this.ReportList.push(data);
      } else if (data.ModuleName == 'ServiceDetails') {
        this.ServiceDetailsList.push(data);
      } else if (data.ModuleName == 'Dashboard') {
        this.DashboardList.push(data);
      } else if (data.ModuleName == 'Control') {
        this.ControlList.push(data);
      } else if (data.ModuleName == 'Data') {
        this.Datalist.push(data);
      } else if (data.ModuleName == 'Data') {
        this.Datalist.push(data);
      } else if (data.ModuleName == 'Process') {
        this.Processlist.push(data);
      } else if (data.ModuleName == 'ProductionReports') {
        this.ProductionReportslist.push(data);
      }
    }
  }

  // Get Meter Report Details
  GetMeterReportDetails(MeterMasterID) {
    this.reportservice.GetUserwiseReportList(MeterMasterID).subscribe(
      (result) => {
        if (result) {
          if (result != null) {
            this.MeterReportList = result;
          }
        }
      },
      (error) => {}
    );
  }

  // Used for toggle menu on click menu icon
  ToggleMenu() {
    this.clickOnmenu = !this.clickOnmenu;
    this.SideMenuclicked.emit(this.clickOnmenu);
  }

  // Call on click any menu
  MenuClick(menu) {
    menu.isclicked = true;
  }

  // Call on click logout
  LogOut() {
    this.userService.logOut();
    this.router.navigate(['/login']);
  }

  // get Company Details
  GetCompanyDetails(CompanyCode) {
    this.companyservice.GetCompanyDetailsByCompanyCode(CompanyCode).subscribe(
      (result) => {
        if (result) {
          this.IsForProcesses = result.IsForProcesses;
        }
      },
      (error) => {}
    );
  }

  // Set Location
  SetLocation(index, ScreenName) {
    localStorage.setItem('ThisScreenName', ScreenName);
    if (index == 0) {
      localStorage.setItem('IsFromUserReport', 'N');
    } else {
      localStorage.setItem('IsFromUserReport', 'Y');
    }
  }

  // Set Location
  SetMRLocation(ScreenName) {
    localStorage.setItem('ThisScreenName', ScreenName);
    localStorage.setItem('MeterId', this.MeterMasterId.toString());
  }
}
